/**
 * help-web's default greeting headline. The approved canvas accents the brand word in `--primary`
 * (`greeting-accent-word-on-background`), which a plain string cannot express and which the shared kit
 * may not carry (AC 1: no help.com-specific strings). The intent greeting from
 * `GET /api/chat/intent` replaces this node wholesale when the backend supplies one.
 */
export function DefaultGreeting() {
  return (
    <>
      What can I <span className="text-primary">help.com</span> you with?
    </>
  );
}
